/**
 * Перевод продуктовых фраз, собранных сервером (§22, §31).
 *
 * Сервер присылает код, подстановки и свой текст. Переводим по коду; текст
 * сервера — запасной вариант для кода, которого клиент ещё не знает.
 */
import type { Notice } from '@alterium/shared';
import { i18n } from './index';

export function noticeText(item: Notice): string {
  return i18n.t(`notice.${item.code}`, {
    ...(item.params ?? {}),
    defaultValue: item.message,
  });
}
